const damStatusColor = [
  {
    label: '',
    rangeTitle: 'ข้อมูลไม่เพียงพอ',
    statusColor: '#bdbdbd',
    constrastColor: '#000',
    fontSize: '12px',
  },
  {
    label: 'น้อยวิกฤต',
    rangeTitle: '<=30',
    statusColor: '#ffc000',
    constrastColor: '#000',
    fontSize: '12px',
  },
  {
    label: 'น้อย',
    rangeTitle: '>30',
    statusColor: '#00b050',
    constrastColor: '#000',
    fontSize: '12px',
  },
  {
    label: 'ปานกลาง',
    rangeTitle: '>50',
    statusColor: '#003cfa',
    constrastColor: '#fff',
    fontSize: '12px',
  },
  {
    label: 'มาก',
    rangeTitle: '>80',
    statusColor: '#ff0000',
    constrastColor: '#fff',
    fontSize: '12px',
  },
  {
    label: 'ล้นเขื่อน',
    rangeTitle: '>100',
    statusColor: '#c70000',
    constrastColor: '#fff',
    fontSize: '12px',
  },
];

export default damStatusColor;
